import React, { useState, useContext } from "react";
import "../../styles/constituencyManagement.css";
import { ToastContainer } from "react-toastify";
import { MdAdd } from "react-icons/md";
import ConstituencyContext from "../../context/constituencyContext";
import AddSocialMedia from "./AddSocialMedia";
import SocialMediaList from "./SocialMediaList";

const Result = () => {
  const constituencyContext = useContext(ConstituencyContext);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showSMModal, setShowSMModal] = useState(false);

  const handleEditModal = () => {
    setShowEdit(true);
  };
  const handleDeleteModal = () => {
    setShowDelete(true);
  };
  const handleAddSocial = () => {
    setShowSMModal(true);
  };

  return (
    <div className='constituency-section'>
      <ToastContainer />

      <div className='pageTitle flex items-center justify-between pr-5'>
        <div className='heading-sec pl-4'>
          <h1 className='heading-text'>Social Media Dashboard</h1>
        </div>
        <div className='flex items-center'>
          {/* <button className='rounded-lg mr-2' onClick={handleEditModal}>
            Edit Constituency
          </button>
          <button className='rounded-lg mr-2' onClick={handleDeleteModal}>
            Delete Constituency
          </button> */}
          <button className='rounded-lg mr-2' onClick={handleAddSocial}>
            <MdAdd /> Add Social Media Data
          </button>
        </div>
      </div>

      {/* <EditConstituency
        isOpen={showEdit}
        setShowEdit={setShowEdit}
        isAddMode={constituencyContext.isAddMode}
      />
      <DeleteConstituency isOpen={showDelete} setShowDelete={setShowDelete} /> */}
      
      {/* <AddApprovalRatingShape 
        isOpen={showSMModal} 
        setShowSMModal={setShowSMModal}
      /> */}
      <AddSocialMedia
        isOpen={showSMModal} 
        setShowSMModal={setShowSMModal}
      />

      <div className='constituency-map'>
        {/* <ConstituencyTabs /> */}
        <SocialMediaList/>
      </div>
    </div>
  );
};

export default Result;
